module.exports = __webpack_public_path__ + "media/images/howitworks-art-3-e9a8d545f4972c794091ec44c68489c6.svg";